export const redirectToMainPage = () => {
    window.location.href = 'https://batna.pro';
};
